/* eslint-disable react/prop-types */
import React, { useState, useRef } from 'react';
import PrescriptionLogo from '../../../assets/Prescription.png'
import InvoiceLogo from '../../../assets/invoice1.png'
import { TbHeartPlus } from 'react-icons/tb'
import { GrLocationPin } from 'react-icons/gr'
import './Header.scss'
import { useNavigate, useParams } from 'react-router-dom';
import { Fragment } from 'react';
import PrescriptionModal from './PrescriptionModal';
import moment from 'moment';
import { generateOcs } from '../../../utils/ocs-generator';
// import { request } from '../../../config/helpers/axios-instance';
import { toast } from 'react-toastify';
import Modal from '../../../components/Modal'
import SelectAddress from '../../../components/SelectAddress';
import { CustomModalForm } from '../../../components/modal-forms';
import CreateAddress from '../../../components/modal-forms/create-address';
import useModal from '../../../hooks/custom-hooks/useModal';
import OCSCreateModal from '../../../components/ocs/OCSCreateModal';
import { useAddModalMain } from '../../../contexts/address-modal/AddModal';
// import PaymentLinkModal from '../../../components/payment-link/PaymentLinkModal';
import GetAddressByUserMappingId from '../../../hooks/fetch-hooks/get-address-by-userid/get-address-by-userid';
import PartnerAcko from '../../../components/partner/partner-acko';
import { checkForShowMissingTimingsError } from '../../../utils/orderUtils';
import { checkOcsReadiness } from '../../../utils/ocsReadiness';
import OrderPackedButton from '../../../components/order-packed/OrderPackedButton';
import RaiseMyRxConsultationButton from './RaiseMyRxConsultationButton';
import { CreateHinaiBilling } from '../../../hooks/update-hooks/billing/create-hinai-billing';
import UserPatientModal from './UserPatientModal';
import ExtraItemsModal from './ExtraItemsModal';
import { TENANT_COMPANY_MAP } from '../../../utils/constants';
import Cookies from "js-cookie";
//import { getTenantId } from '../../../utils/helpers';

const Header = ({ userData, orderData, updatePrescription, refetch, addNewItem }) => {
    const { orderId } = useParams();
    const navigate = useNavigate();
    const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
    const [showUserPatientModal, setShowUserPatientModal] = useState(false);
    const [modal, setModal] = useState(false);
    const [isBillingInProgress, setIsBillingInProgress] = useState(false);
    const [hasBillingBeenClicked, setHasBillingBeenClicked] = useState(false); // Add this line
    const handleShowPrescriptionModal = () => setShowPrescriptionModal(true);
    const handleClosePrescriptionModal = () => { setShowPrescriptionModal(false) };
    const { isShowing: isCreateFormShowing, toggle: toggleCreateAddressForm } = useModal();
    const { AddopenModal, AddcloseModal } = useAddModalMain();
    const { data: patientAddress } = GetAddressByUserMappingId(orderData.mappingId);
    const { mutate: createHinaiBilling, isLoading: isBillingLoading } = CreateHinaiBilling(orderData.id);
    const tenantId = Cookies.get("tenantId");
    const disableUserPatientModal = tenantId === TENANT_COMPANY_MAP.EAZY;
    //const tenantId = getTenantId();
    //const isEasydose = process.env.REACT_APP_EASYDOSE_FEATURE_ENABLED === 'true' && tenantId === TENANT_COMPANY_MAP.EAZY;
    const isEasydose = false;


    // Hidden escape hatch for the OCS readiness rules: tap the order ID 10 times within 5s.
    const [ocsBypassArmed, setOcsBypassArmed] = useState(false);
    const orderIdTaps = useRef([]);
    const handleOrderIdTap = () => {
        const now = Date.now();
        orderIdTaps.current = [...orderIdTaps.current.filter((t) => now - t < 5000), now];
        if (orderIdTaps.current.length < 10) return;
        orderIdTaps.current = [];
        toast.warn(ocsBypassArmed ? 'OCS readiness checks re-enabled' : 'OCS readiness checks bypassed for this page');
        setOcsBypassArmed(!ocsBypassArmed);
    };

    const handleGenerateOcs = async (orderData, patientName, selection) => {
        if (!orderData || !patientName) {
            toast.error("Order data or patient name is not available")
            return
        }
        generateOcs(orderData, patientName, orderData.id, selection)
    }

    // "Add Extra Items" -- meds that must be packed separately from the pouches. Read back
    // on the logistics console's Orders tab as "Meds to Pack Separately".
    // `refetch` so the button's own state reflects the saved value without a page reload.
    function ExtraItemsClickHandler() {
        AddopenModal(() => (
            <ExtraItemsModal
                orderId={orderData?.id}
                initialValue={orderData?.additionalDetails?.extraItems || ''}
                onClose={AddcloseModal}
                onSaved={() => { if (refetch) refetch(); }}
            />
        ));
    }

    async function OcsClickHandler() {
        if (checkForShowMissingTimingsError(orderData) && checkOcsReadiness(orderData, ocsBypassArmed)) {
            AddopenModal(() => <OCSCreateModal handleGenerateOcs={handleGenerateOcs} orderData={orderData} />)
        }
    }

    function AckoOcsClickHandler() {
        if (checkForShowMissingTimingsError(orderData)) {
            AddopenModal(() => PartnerAcko(orderData, AddcloseModal))
        }
    }

    function toggleModal() {
        setModal(!modal);
    }

    // const handleSendPaymentLink = async (data) => {
    //     try {
    //         let res = await request({
    //             url: data?.isCash ? '/payment/admin/addCashPayment' : '/payment/admin/generatePaymentLink',
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             data: {
    //                 "orderId": parseInt(data?.id),
    //                 "quotationId": parseInt(data?.quotationId),
    //                 "userId": data?.user?.userId,
    //                 "amount": parseFloat(data?.amount),
    //                 "gateway": data?.isCash ? "CASH" : "PAYU",
    //                 "currency": "INR",
    //                 "user": {
    //                     "name": data?.user?.name,
    //                     "phone": data?.user?.phone
    //                 }
    //             }
    //         })

    //         if (res && res.data.success) {
    //             toast.success("Payment link sent successfully")
    //             AddcloseModal()
    //             refetch()
    //         } else {
    //             toast.error("Failed to send payment link")
    //         }
    //         return res
    //     } catch (err) {
    //         toast.error("Failed to send payment link")
    //     }
    // }

    // async function handlePaymentLinkModal(orderData) {
    //     AddopenModal(() => <PaymentLinkModal handleSendPaymentLink={handleSendPaymentLink} orderData={orderData} onClose={AddcloseModal} isQuotation={false} />)
    // }

    // Update handleHinaiBilling function (around line 104)
    // Update handleHinaiBilling function (around line 107) to use isBillingInProgress:
    // Update handleHinaiBilling function (lines 108-165):
    // Update handleHinaiBilling function (around line 108) - simplify it:
    const handleHinaiBilling = async () => {
        if (!orderData || hasBillingBeenClicked) {
            if (hasBillingBeenClicked) {
                toast.info("Billing process already initiated");
            } else {
                toast.error("Order data not available");
            }
            return;
        }

        // Prevent duplicate billing
        if (orderData?.billingStatus === 'BILLED') {
            toast.info("Billing already completed for this order");
            return;
        }

        // Mark as clicked and set loading state
        setHasBillingBeenClicked(true);
        setIsBillingInProgress(true);

        // Call billing API with no payload - userOrderId is in URL path
        createHinaiBilling(null, {
            onSuccess: (response) => {
                setIsBillingInProgress(false);
                // The toast message is already handled in the CreateHinaiBilling hook
                if (response?.data?.success) {
                    refetch(); // Refresh order data
                }
            },
            onError: (error) => {
                console.error("Billing creation failed:", error);
                setIsBillingInProgress(false);
                // Optionally reset hasBillingBeenClicked on error if you want to allow retry:
                // setHasBillingBeenClicked(false);
            }
        });
    };

    return (
        <Fragment>
            {modal && <Modal title={"Select Address"} onClose={toggleModal}>
                <SelectAddress orderData={orderData} user={userData.User} orderId={orderId} closeModal={toggleModal} refetch={refetch} toggleCreateAddressForm={toggleCreateAddressForm} />
            </Modal>
            }
            <CustomModalForm
                isShowing={isCreateFormShowing}
                hide={toggleCreateAddressForm}
                title="Create User"
                style={{ width: "60%", maxWidth: "60%" }}
                className="modal-form">
                <CreateAddress refetch={refetch} selectedUser={userData.User} toggle={toggleCreateAddressForm} optional={toggleModal} />
            </CustomModalForm>
            <PrescriptionModal updatePrescription={updatePrescription} addNewItem={addNewItem} onClose={handleClosePrescriptionModal} show={showPrescriptionModal} prescription={userData.prescription} />
            <UserPatientModal
                open={showUserPatientModal}
                onClose={() => setShowUserPatientModal(false)}
                orderId={orderId}
                mappingId={orderData?.mappingId}
                mapUserPatient={orderData?.mapUserPatient}
                refetch={refetch}
            />

            <div className='bg-[white] px-10 py-3 rounded-lg border border-gray-300' >
                <div className='flex flex-row flex-grow basis-0 justify-around items-center gap-4' >
                    <div className='header_order-number flex flex-col gap-1' onClick={handleOrderIdTap} >
                        #{orderId}
                        {orderData?.billingStatus === 'BILLED' && (
                            <div className="text-xs text-green-600 font-semibold">
                                ✓ Billed (Invoice: {orderData?.hinaiInvoiceNo || 'N/A'})
                            </div>
                        )}
                    </div>
                    <div className='flex justify-center gap-3 flex-auto' >
                        <div className='flex flex-col items-center'>
                            <div
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        if (disableUserPatientModal) return;
                                        setShowUserPatientModal(true);
                                    }
                                }}
                                onClick={() => {
                                    if (disableUserPatientModal) return;
                                    setShowUserPatientModal(true);
                                }}
                                className={`relative flex justify-around items-center gap-3 border-2 px-4 py-3 rounded-lg ${disableUserPatientModal ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:bg-gray-50'}`}
                            >
                                <span className='text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1'>Patient</span>
                                <div className='name-logo' >
                                    {userData.Patient.name.split(' ')
                                        .map(word => word.charAt(0))
                                        .join('')
                                    }
                                </div>
                                <div>
                                    <strong className='text-md' >{userData.Patient.name}</strong>
                                    <p className='text-sm'>{userData.Patient.contact_no}</p>
                                    <p className='text-sm'>{moment().diff(moment(userData.Patient.dob), 'years') + ' years'}</p>
                                    <p className='text-sm'>{userData.Patient.gender}</p>
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-col items-center'>
                            <div
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        if (disableUserPatientModal) return;
                                        setShowUserPatientModal(true);
                                    }
                                }}
                                onClick={() => {
                                    if (disableUserPatientModal) return;
                                    setShowUserPatientModal(true);
                                }}
                                className={`relative flex justify-around items-center gap-3 border-2 px-4 py-3 rounded-lg ${disableUserPatientModal ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:bg-gray-50'}`}
                            >
                                <span className='text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1'>Caregiver</span>
                                <div className='name-logo' >
                                    {userData.User.name.split(' ')
                                        .map(word => word.charAt(0))
                                        .join('')
                                    }
                                </div>
                                <div>
                                    <strong className='text-md' >{userData.User.name}</strong>
                                    <p className='text-sm'>{userData.User.contact_no}</p>
                                    <p className='text-sm'>{moment().diff(moment(userData.User.dob), 'years') + ' years'}</p>
                                    <p className='text-sm'>{userData.User.gender}</p>
                                </div>
                                <div className='absolute right-2 bottom-2' >
                                    <TbHeartPlus />
                                </div>
                            </div>
                        </div>
                        <div className='border-2 px-8 py-3 rounded-lg relative'  >
                            {
                                userData?.address ? <div className='cursor-pointer' onClick={() => { setModal(true) }}>
                                    <strong>{userData?.address?.line}</strong>
                                    <p className='text-sm'>{userData?.address?.state}</p>
                                    <p className='text-sm'>{userData?.address?.district}</p>
                                    <p style={{
                                        border: '1px solid #049079',
                                        width: 'max-content'
                                    }} className='rounded-xl text-xs  px-2 py-1' >{userData?.address?.pincode}</p>
                                    <div className='absolute right-2 bottom-2' >
                                        <GrLocationPin />
                                    </div>
                                </div> : <p onClick={patientAddress?.data?.data && patientAddress?.data?.data?.length > 0 ? toggleModal : toggleCreateAddressForm} >No Address Found</p>
                            }

                        </div>
                    </div>
                    <div className='flex flex-row gap-x-10' >
                        <button onClick={handleShowPrescriptionModal} className={(userData?.prescription?.links?.length > 0 ? "" : "animate-bounce")}>
                            <img style={{ height: '60px' }} src={PrescriptionLogo} />
                        </button>
                        <a href={userData.evitalRx} target='_blank' rel="noreferrer" className={(userData?.evitalRx?.length > 0 ? "" : "animate-bounce")}>
                            <img style={{ height: '60px' }} src={InvoiceLogo} />
                        </a>

                        {isEasydose && (
                            <button
                                onClick={handleHinaiBilling}
                                disabled={isBillingLoading || isBillingInProgress || hasBillingBeenClicked || !orderData || orderData?.billingStatus === 'BILLED'}
                                className={`p-2 text-lg rounded-xl text-white-50 flex flex-row items-center gap-1 disabled:opacity-50 transition-all ${isBillingLoading || isBillingInProgress || hasBillingBeenClicked || orderData?.billingStatus === 'BILLED'
                                    ? 'bg-gray-400 cursor-not-allowed opacity-50 pointer-events-none'
                                    : 'bg-teal-500 hover:bg-teal-600'
                                    }`}
                                title={
                                    orderData?.billingStatus === 'BILLED'
                                        ? "Billing already completed"
                                        : hasBillingBeenClicked
                                            ? "Billing process initiated"
                                            : "Generate bill in Hinai system"
                                }
                            >
                                {orderData?.billingStatus === 'BILLED'
                                    ? '✓ Billed'
                                    : isBillingInProgress || isBillingLoading
                                        ? 'Processing...'
                                        : hasBillingBeenClicked
                                            ? 'Bill Generated'
                                            : 'Generate Bill'}
                            </button>
                        )}
                    </div>
                    {
                        orderData?.quotationId &&
                        <div>
                            <button className='p-2 text-lg  rounded-xl bg-orange-500 text-white-50 flex flex-row items-center gap-1 disabled:opacity-50'
                                onClick={() => { return navigate(`/quotation/edit/${orderData?.quotationId}`, { replace: true }) }} >Go to Quotation</button>
                        </div>
                    }
                    <div className='flex flex-row flex-grow flex-wrap basis-0 gap-5'>
                        {/* {!isFullyPaid && (
                            <button className='p-2 text-lg  rounded-xl bg-red-500 text-white-50 flex flex-row items-center gap-1 disabled:opacity-50' onClick={() => handlePaymentLinkModal(orderData)} >Send payment link</button>
                        )} */}
                        <button
                            className={`p-2 rounded-xl text-[white] text-center text-xl flex-auto cursor-pointer ${orderData?.additionalDetails?.extraItems ? 'bg-amber-500' : 'bg-elm-500'}`}
                            onClick={ExtraItemsClickHandler}
                            title={orderData?.additionalDetails?.extraItems || 'No extra items recorded'}
                        >
                            {orderData?.additionalDetails?.extraItems ? 'Extra Items \u26A0' : 'Add Extra Items'}
                        </button>
                        <button className="p-2 bg-elm-500 rounded-xl text-[white] text-center text-xl flex-auto cursor-pointer" onClick={OcsClickHandler} >Ocs</button>
                        <button className="p-2 bg-elm-500 rounded-xl text-[white] text-center text-xl flex-auto cursor-pointer" onClick={AckoOcsClickHandler} >Acko Ocs</button>
                        <button className="p-2 bg-[#001524] rounded-xl text-[white] text-center text-xl flex-auto cursor-pointer" onClick={() => {
                            if (checkForShowMissingTimingsError(orderData)) {
                                navigate(`/drx/${orderId}`)
                            }
                        }} >DRX</button>
                        <OrderPackedButton orderId={orderId} />
                        <RaiseMyRxConsultationButton orderId={orderId} />
                    </div>
                </div>
            </div>
        </Fragment >
    )
}

export default Header;